const hosts = {
  CTL_AUTHENTICATOR_SERVER: 'http://authenticator:8080',
  CTL_DATA_SERVER: 'http://data-server:8080',
  CTL_IMAGE_SERVER: 'http://image-server:8080',
  CTL_ELASTIC_SEARCH: '',
  AIPF_PORTAL_DOMAIN: 'http://aipf-portal:3000',
} as const;

export default hosts;
